module.exports = __webpack_public_path__ + "img/magica.a8437911.png";